import { render, staticRenderFns } from "./CertificationDetails.vue?vue&type=template&id=f506d8a2&scoped=true&"
import script from "./CertificationDetails.vue?vue&type=script&lang=js&"
export * from "./CertificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./CertificationDetails.vue?vue&type=style&index=0&id=f506d8a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f506d8a2",
  null
  
)

export default component.exports